// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported, setConsent } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyDPWVtbJ1sTmUkiSAMCTRcNJMD7b1jXsK8",
    authDomain: "classcompassuk.firebaseapp.com",
    projectId: "classcompassuk",
    storageBucket: "classcompassuk.firebasestorage.app",
    messagingSenderId: "795719260116",
    appId: "1:795719260116:web:195e139935d876fbd7e841",
    measurementId: "G-V2L455YDKT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Authentication
export const auth = getAuth(app);

// Analytics (GA4) is NO LONGER initialised on load. It is a non-essential
// analytics tracker and must not fire until the visitor has given consent.
// Consent is wired up via src/utils/consent.js, which calls the helpers below.
let analytics = null;

const isLocalhost = () =>
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

// Update Firebase/GA4 consent state (Consent Mode). Safe to call before or
// after analytics is initialised; denied is the effective default.
export const setFirebaseConsent = async (granted) => {
    try {
        if (!(await isSupported())) return;
        const value = granted ? 'granted' : 'denied';
        setConsent({
            analytics_storage: value,
            ad_storage: value,
            ad_user_data: value,
            ad_personalization: value,
        });
    } catch (_) { /* analytics unsupported / blocked — ignore */ }
};

// Lazily initialise GA4 (Firebase Analytics). Call ONLY after consent.
// No-op on localhost or where analytics isn't supported.
export const initAnalytics = async () => {
    if (analytics) return analytics;
    if (isLocalhost()) return null;
    try {
        if (!(await isSupported())) return null;
        analytics = getAnalytics(app);
        return analytics;
    } catch (_) {
        return null;
    }
};

export const getAnalyticsInstance = () => analytics;
export default app;
